export default "__VITE_ASSET__Dw$InJc2__"